import axios, { Axios } from "axios";
import * as crypto from "crypto-browserify";
import { Buffer } from "buffer";
import AES from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";
import { get, isString, orderBy } from "lodash";
import { BallotStatusType, cookieKeysEnum, EXTERNAL_APP_URL, NEGATIVE_RULING_OPTIONS } from "../models/common.models";
import moment from "moment";
import Cookies from "universal-cookie";
import { setCurrentLocationStorage } from "../common.actions";
import { LEFT_NAVIGATION_PAGE_URL, MODULES,  NAVIGATIONHEADER, PAGE_CONFIG } from "../models/navigation.models";
import { CompletionIntervalList } from "../pages/WorkItemDetails/workItemDetail.model";
import { AppModule, Apps, BALLOT_ITEM_STATUSES, BALLOT_LEVEL_ID, BallotStatusEnum, BallotTypeEnum, DRAFT_STATUSES, DraftActionId, WI_STATUS_FIELDS_MAP } from "../../common.enum";
import { appConfig } from "./appConfig";

export const Blank_Space_Check_Regex = /^(?=.*\S).+$/;
export const Name_Regex = /^[A-Za-z]*$/;
export const NameWithWhiteSpace_Regex = /^[a-zA-Z ]*$/;
export const AlphaNumeric_Regex = /^[A-Za-z0-9]*$/;
export const AlphaNumericWitDash_Regex = /^[A-Za-z0-9-]*$/;
export const Number_Regex = /^[0-9]*$/;
export const PositiveRegex = /^\d+(\.\d{1,2})?$/;
export const MinDate = "01/01/1900";
export const minDateforReport = "01/01/2017";
export const COOKIES = new Cookies();

const securityKey = "aes-256-cbc";

const getEncryptionKey = () => {
  try {
    return appConfig.getEncryptionKey();
  } catch (e) {
    return "";
  }
};

export const encrypt = (text) => {
  try {
    if (text) {
      const encryptionKey = getEncryptionKey();
      if (!encryptionKey) {
        return text;
      }
      text = text.toString();
      let iv = crypto.randomBytes(Number(process.env.REACT_APP_STORAGE_IV_LENGTH));
      let cipher = crypto.createCipheriv(securityKey, Buffer.from(encryptionKey), iv);
      let encrypted = cipher.update(text);
      encrypted = Buffer.concat([encrypted, cipher.final()]);
      return iv.toString("hex") + ":" + encrypted.toString("hex");
    }
    return text;
  } catch (e) {
    console.log("Exception in Encryption", e);
  }
};

export const decrypt = (text) => {
  try {
    if (text) {
      const encryptionKey = getEncryptionKey();
      if (!encryptionKey) {
        return text;
      }
      text = text.toString();
      let textParts = text.split(":");
      if (textParts && textParts.length > 0) {
        let iv = Buffer.from(textParts.shift(), "hex");
        let encryptedText = Buffer.from(textParts.join(":"), "hex");
        let decipher = crypto.createDecipheriv(securityKey, Buffer.from(encryptionKey), iv);
        let decrypted = decipher.update(encryptedText);
        decrypted = Buffer.concat([decrypted, decipher.final()]);
        return decrypted.toString();
      }
    }
    return text;
  } catch (e) {
    try {
      if (text) {
        const encryptionKey = getEncryptionKey();
        const bytes = AES.decrypt(text, encryptionKey as string);
        const decryptedData = JSON.parse(bytes.toString(Utf8));
        return decryptedData;
      }

      return text;
    } catch (e) {
      console.log("Exception in Decryption", e);
    }
  }
};

export const cacheManager = {
  getItem: (key: any, isDecrypt = true) => {
    if (isDecrypt) {
      return decrypt(window.localStorage.getItem(key));
    } else {
      return window.localStorage.getItem(key);
    }
  },
  setItem: (key: any, value: any) => {
    let string = isString(value) ? encrypt(value) : encrypt(JSON.stringify(value));
    window.localStorage.setItem(key, string);
  },
  removeItem: (key: any) => {
    window.localStorage.removeItem(key);
  },
  clearSession: () => {
    window.localStorage.clear();
  },
};

export const formatDateToMMDDYYYYHHMMSS = (date) => {
  return moment.utc(date).local().format("MM/DD/YYYY HH:mm:ss");
};

export const formateUTCDate= (fromat="MM/DD/YYYY HH:mm:ss")=>{
  return  moment.utc().format(fromat);
}

export const cookiesManager = {
  setCookie: (key: any, value: any, isParentOrigin: any = true) => {
    let _date = new Date();
    _date.setTime(_date.getTime() + 60 * 60 * 24 * 1000); // TODO : Remove Cookies in 24Hrs.
    let options = {
      path: "/",
      expires: _date,
      domain: isParentOrigin ? getDomainFromSubDomain(window.location.hostname) : window.location.hostname,
      secure: window.location.hostname === "localhost" ? false : true,
    };
    COOKIES.set(key, encrypt(value), options);
  },
  getCookie: (key: any, isDecrypt: any = true, isParentOrigin: any = true) => {
    let options: any = {
      path: "/",
      domain: isParentOrigin ? getDomainFromSubDomain(window.location.hostname) : window.location.hostname,
      secure: window.location.hostname === "localhost" ? false : true,
    };
    if (isDecrypt) {
      return decrypt(COOKIES.get(key, options));
    } else {
      return COOKIES.get(key, options);
    }
  },
  removeCookie: (key: any, isParentOrigin: any = true) => {
    let options = {
      path: "/",
      domain: isParentOrigin ? getDomainFromSubDomain(window.location.hostname) : window.location.hostname,
      secure: window.location.hostname === "localhost" ? false : true,
    };
    COOKIES.remove(key, options);
  },
};

export function utcDateTimeToLocalDateTime(date: any) {
  return moment.utc(date).local().format("MM/DD/YYYY hh:mm A");
}

export function utcDateTimeSecondToLocalDateTime(date: any, format = "MM/DD/YYYY hh:mm:ss A") {
  return moment.utc(date).local().format(format);
}

export function utcDateTimeSecondToDate(date: any, format = "MM/DD/YYYY hh:mm:ss A") {
  return moment.utc(date).format(format);
}

// Change format to MMM dd, yyyy
export function dateFormatToStringWithDateAndTime(date: any) {
  date = utcDateTimeToLocalDateTime(date);
  return moment(date).format("ll") + " at " + moment(date).format("LT");
}

export const getCookie = (key: any) => {
  let name = key + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const getFileType = (fileName: any) => {
  let lastIndex = fileName.lastIndexOf(".");

  if (fileName.length > lastIndex + 1 && lastIndex > 0) {
    return fileName.substring(lastIndex + 1).toLowerCase();
  }

  return fileName;
};

export const getCurrentlyShowingItemsInGrid = (pageNumber: any, pageSize: any, totalItems: any) => {
  if (pageNumber > 0 && pageSize > 0 && totalItems > 0) {
    let startIndex = pageNumber * pageSize - pageSize + 1;
    let lastIndex = totalItems >= pageNumber * pageSize ? pageNumber * pageSize : totalItems;

    return `${startIndex} - ${lastIndex} of ${totalItems} items`;
  }

  return "";
};

export const scrollToTopOfPage = () => {
  let scrollElement = document.getElementById("root");

  if (scrollElement) {
    scrollElement.scrollTop = 0;
  }
};

// Extract a query string value from the url
export const extractValueFromUrl = (url: any, paramName: any) => {
  let regex: any;
  if (url && url.indexOf(paramName) === 0) {
    regex = new RegExp(paramName + "=([^&#]*)", "i");
  } else {
    regex = new RegExp("[?&]" + paramName + "=([^&#]*)", "i");
  }
  let string = regex.exec(url);

  return string ? string[1] : null;
};

export const getMessage = (messageList: any, message: any) => {
  return get(messageList, message);
};

export const getSortOrderFromHeaderClick = (event: any) => {
  let orderType = 0; // 0 for Ascending order, 1 for descending order

  if (event.target.attributes.getNamedItem("data-order")) {
    orderType = event.target.attributes.getNamedItem("data-order").value;
  } else if(event.currentTarget.attributes.getNamedItem("data-order")) {
    orderType = event.currentTarget.attributes.getNamedItem("data-order").value;
  } else {
    orderType = event.target.parentElement.attributes.getNamedItem("data-order").value;
  }

  return orderType;
};

export const resetHeaderSortOrder = (list: any) => {
  list.map((item: any) => {
    item.orderBy = 0;
    item.orderByIcon = 0;
    if (item.title === "Modified Date/Time") {
      item.orderBy = 0;
      item.orderByIcon = 2;
    } else if (item.sortKey === "WorkItemNumber") {
      item.orderBy = 0;
      item.orderByIcon = 2;
    }
  });
};

export const formatListDataForAutoSearch = (list: any, column: any = null) => {
  if (list && list.length > 0) {
    let result: any = [];
    list.map((item: any) => {
      result.push({ title: item.Title || item.text || item[column] });
    });

    return result;
  }
  return [];
};

export const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const generateUUIDForAutofill = () => {
  let dt = new Date().getTime();
  let uuid = "xxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};

// Replace String at Selected Index
export const replaceAt = (string: any, index: any, replacement: any) => {
  return string.substr(0, index) + replacement + string.substr(index + replacement.length);
};

// Validate Params Keys while Url Comes from Request
export const validateUrlParams = (routeUrls: any, currentPath: any) => {
  currentPath = currentPath && replaceAt(currentPath, 0, " ");
  currentPath = currentPath && currentPath.trim();
  let routeUrlSplitParamsArray = routeUrls && routeUrls.split("/");
  let currentUrlSplitParamsArray = currentPath && currentPath.split("/");
  if (routeUrls.indexOf("/:") > -1 && currentPath.indexOf(routeUrlSplitParamsArray[0]) > -1 && currentPath.indexOf(routeUrlSplitParamsArray[1]) > -1) {
    for (let i = 0; i < routeUrlSplitParamsArray.length; i++) {
      if (currentPath.indexOf(routeUrlSplitParamsArray[i]) === -1) {
        routeUrlSplitParamsArray[i] = currentUrlSplitParamsArray[i];
      }
    }
    return routeUrlSplitParamsArray && routeUrlSplitParamsArray.join("/");
  }
  return routeUrls;
};

// Validate Request Url For Permission
export const validateNavigationFromUrl = (currentPath: any) => {
  const beautifyCurrentPath = (url: any) => url !== "" && url.replace("/", "");
  let navigationModal: any = NAVIGATIONHEADER;
  let result: any = [];
  if (navigationModal && navigationModal.length > 0) {
    for (let i: any = 0; i < navigationModal.length; i++) {
      let modulesItems = navigationModal[i][MODULES[i]];
      if (modulesItems && modulesItems.length > 0) {
        result = modulesItems.filter((itemsList: any) => {
          return currentPath === validateUrlParams(itemsList.routeUrl, currentPath);
        });
        if (result && result.length > 0) {
          return { selectedSingleResult: result, selectedFullResult: modulesItems, currentSearchResult: result[0] };
        }
      }
    }
  }
};

export const toUTCDateAndTime = (date:any, format: any) => {
  return moment.utc(moment(date)).format(format);
};
const getStoredPermissions = () => {
  try {
    const cachedValue = cacheManager.getItem("privilegeRoleModel", true);
    if (!cachedValue) {
      return [];
    }

    const parsedValue = typeof cachedValue === "string" ? JSON.parse(cachedValue) : cachedValue;
    if (!Array.isArray(parsedValue) || parsedValue.length === 0) {
      return [];
    }

    return get(parsedValue[0], "permissions") || [];
  } catch (e) {
    const cachedValue = cacheManager.getItem("privilegeRoleModel", false);
    if (!cachedValue) {
      return [];
    }

    const parsedValue = typeof cachedValue === "string" ? JSON.parse(cachedValue) : cachedValue;
    if (!Array.isArray(parsedValue) || parsedValue.length === 0) {
      return [];
    }

    return get(parsedValue[0], "permissions") || [];
  }
};

// Filter Permission Url if Allow
export const filterPermissionUrl = (requestUrl: any, method: any = undefined) => {
  const permissions = getStoredPermissions();
  let isPageAuthorized =
    permissions &&
    permissions.length > 0 &&
    permissions.filter((items: any) => {
      if (method) {
        let hasAccess = false;
        if (Array.isArray(requestUrl.oslUrl)) {
          hasAccess = requestUrl.oslUrl.filter((x: any) => x.url == items.resource && items.methods.indexOf(x.verb) > -1 && items.action === "allow").length > 0;
        } else {
          hasAccess = items.methods.indexOf(method) > -1 && requestUrl.oslUrl === items.resource && items.action === "allow";
        }

        // Check for sub routes in case not found in parent
        if (!hasAccess) {
          hasAccess =
            items.subRoutes.length > 0 &&
            items.subRoutes.find((subItem: any) => {
              if (method) {
                return subItem.methods.indexOf(method) > -1 && requestUrl.oslUrl === subItem.resource && subItem.action === "allow";
              }

              return requestUrl.oslUrl === subItem.resource && subItem.action === "allow";
            });
        }
        return hasAccess;
      }
      return requestUrl.oslUrl === items.resource && items.action === "allow";
    });
  return isPageAuthorized;
};

// Validate Auth or Not
export const allowPermissionForAuth = (isPageAuthorized: any) => {
  if (isPageAuthorized && isPageAuthorized.length > 0) {
    return true;
  }
  return false;
};

// Set Route Urls
export const routeNavigationUrl = (page: any, permissionType: any = null, paramsKey: any = []) => {
  // Permission Type Could be Null in case of Directly generaing Unique Keys on Page Params;
  let keys = permissionType !== null ? `${PAGE_CONFIG.uniqueKey(page, permissionType)}` : `${page}`; // Generated Keys for Private Routes
  const setParamsOnUrlRoutes = (selectedUrl: any) => {
    let ParamsIndex = -1;
    let url = selectedUrl && selectedUrl.length > 0 && selectedUrl[0].routeUrl;
    url = url && url.split("/");
    if (url && url.length > 0) {
      for (let i = 0; i < url.length; i++) {
        if (url[i].indexOf(":") > -1) {
          ParamsIndex++;
          url[i] = paramsKey[ParamsIndex];
        }
      }
    }
    return url && url.join("/");
  };
  let moduleUrls: any = [];
  NAVIGATIONHEADER.map((moduleItem: any, index: any) => moduleItem[MODULES[index]]).map((result: any) => {
    result.map((items: any) => items.uniqueKey === keys && moduleUrls.push(items));
  });
  if (moduleUrls && moduleUrls.length > 0) {
    if (paramsKey.length > 0) {
      return `/${setParamsOnUrlRoutes(moduleUrls)}`;
    }
    return `/${moduleUrls[0].routeUrl}`;
  }
  return "/";
};

// Get Additional Privilege of Compoenent
export const getModulesAdditionalPrivilege = (selectedUrl: any) => {
  let additionalPermission: any = [];
  NAVIGATIONHEADER && NAVIGATIONHEADER.map((moduleItem: any, index: any) => moduleItem[MODULES[index]] && moduleItem[MODULES[index]].map((subModuleItems: any, subIndex: any) => selectedUrl.additionalPermission && selectedUrl.additionalPermission.length > 0 && selectedUrl.additionalPermission.indexOf(subModuleItems.uniqueKey) > -1 && additionalPermission.push(subModuleItems)));
  return additionalPermission;
};

// Validate All User Permission on Page
export const checkUserPermissionOnPage = (allowedPermission: any, page: any, permissionType: any) => {
  // Generated Keys for Private Routes
  let keys = PAGE_CONFIG.uniqueKey(page, permissionType);
  return allowedPermission && get(allowedPermission, [keys]);
};

// TODO : fetch azure ad code
export const azureAdFetchCode = () => {
  // Validate location get from params while called
  setCurrentLocationStorage();
  let azureTempleteURL = process.env.REACT_APP_AZURE_ROOT_URL + "/<TENENT_ID>/oauth2/authorize?response_type=code&client_id=<CLIENT_ID>&redirect_uri=<REDIRECT_URL>&state=<STATE>&resource=<RESOURCE>";
  azureTempleteURL = azureTempleteURL.replace("<TENENT_ID>", process.env.REACT_APP_TENANT_ID as string);
  azureTempleteURL = azureTempleteURL.replace("<CLIENT_ID>", process.env.REACT_APP_AUTH_CLIENT_ID as string);
  azureTempleteURL = azureTempleteURL.replace("<REDIRECT_URL>", process.env.REACT_APP_REDIRECT_URI as string);
  azureTempleteURL = azureTempleteURL.replace("<STATE>", `${encrypt(Math.random().toString(36) + ":" + getUserAgent().name)}`);
  azureTempleteURL = azureTempleteURL.replace("<RESOURCE>", process.env.REACT_APP_OSL_AD_AUTH_APP_CLIENT_ID as string);
  return azureTempleteURL;
};

export const clearAzureAdAuthCodeAction = () => {
  // TODO : Remove forcefully Clean Session.
  cacheManager.clearSession();
  cookiesManager.removeCookie(cookieKeysEnum.APP_SESSIONID);
  let url = process.env.REACT_APP_AZURE_LOGOUT_URL + "/" + process.env.REACT_APP_TENANT_ID + "/oauth2/logout?post_logout_redirect_uri=" + process.env.REACT_APP_REDIRECT_URI + "/logout";
  return url;
};
export const validateLeftMenuNavigation = (navigation: any, isParent: boolean = false) => {
  const permissions = getStoredPermissions();
  let isPageAuthorized = false;
  if (Array.isArray(navigation.oslUrl) && isParent && permissions && permissions.length > 0) {
    isPageAuthorized = permissions.filter((items: any) => navigation.oslUrl.filter((navitem: any) => navitem.url == items.resource && items.methods.indexOf(navitem.verb) > -1).length > 0 && items.action === "allow").length > 0;
  } else if (!isParent && permissions && permissions.length > 0) {
    isPageAuthorized = permissions.filter((items: any) => items.methods.indexOf(navigation.oslMethod) > -1 && navigation.oslUrl === items.resource && items.action === "allow").length > 0;
  }
  return isPageAuthorized;
};

// Navigation Permission Validate
export const validateNavigationPermission = () => {
  const NAVIGATIONRESULT = NAVIGATIONHEADER;
  let navResult: any = [];
  // Validate Parent Module Permission
  const validateParentModulePermission = async (parentItem: any, index: any) => {
    if (parentItem[MODULES[index]]?.length >= 0) {
      return parentItem[MODULES[index]].filter((result: any) => allowPermissionForAuth(filterPermissionUrl(result, result.oslMethod)));
    }
    return [];
  };
  // Validate Sub Module Permission
  const validateSubModulePermission = (parentItem: any, index: any) => {
    if (parentItem[MODULES[index]]?.length > 0) {
      parentItem[MODULES[index]].map((result: any) => {
        if (!allowPermissionForAuth(filterPermissionUrl(result, result.oslMethod))) {
          if(result.oslUrl != LEFT_NAVIGATION_PAGE_URL.APPLYSTATICURL){
            result.isVisibleOnNavigation = false;
          }
        }
      });
    }
  };
  // Get each navigation values.
  return new Promise((resolve) => {
    if (NAVIGATIONRESULT && NAVIGATIONRESULT.length > 0) {
      navResult = NAVIGATIONRESULT.map((item: any, index: any) => {

        if(item.oslUrl != LEFT_NAVIGATION_PAGE_URL.APPLYSTATICURL){
          let isParentModulePermission = validateParentModulePermission(item, index);
          isParentModulePermission.then((result) => {
            // Check Module Permission
            if (result && result.length === 0) {
             item.isVisibleOnNavigation = false;
            }
          });
        }
      
        // Check Sub Module Permission
        validateSubModulePermission(item, index);
        return item;
      });
    }
    resolve(navResult);
  });
};

export const setLoginDataToCacheManager = (response: any, loginActionType: any = null) => {
  // Perform login Action on Type.
  switch (loginActionType) {
    case "DELETE": // For Delete Token
      cacheManager.removeItem("privilegeRoleModel");
      cacheManager.removeItem("userDetail");
      cacheManager.removeItem("isReactAppAuthorized");
      cacheManager.removeItem(cookieKeysEnum.accessToken);
      cacheManager.removeItem(cookieKeysEnum.oktaToken);
      cookiesManager.removeCookie(cookieKeysEnum.APP_SESSIONID);
      break;
    case "LOGIN": // For Add login/Azure Ad Login Request
      cacheManager.removeItem("current-location"); // TODO : Remove current location from storage.
      cacheManager.setItem("privilegeRoleModel", response.data.privilege.privilegeRoleModel);
      cacheManager.setItem("userDetail", response.data?.privilege?.userDetail);
      cacheManager.setItem("isReactAppAuthorized", true);
      cacheManager.setItem(cookieKeysEnum.accessToken, response.data.accessToken);
      break;
    case "REFRESH": // For Refresh token Request Update
      if (process.env.REACT_APP_LOGIN_BY_AZURE_AD == "true") {
        if (cacheManager.getItem(cookieKeysEnum.accessToken)) {
          cacheManager.removeItem(cookieKeysEnum.accessToken);
        }
        cacheManager.setItem(cookieKeysEnum.accessToken, response.data.accessToken);
      }
      break;
    default:
      break;
  }
};

export const isReactAppAuthorized = () => {
  if (cacheManager.getItem("isReactAppAuthorized")) {
    // VALIDATE THE TOEKN EXIST OR NOT
    if (process.env.REACT_APP_LOGIN_BY_AZURE_AD == "true" && !isTokenExistInCookies()) {
      cacheManager.clearSession(); // Check Access Token Should be Exist In Case of Azure AD
    }
    return true;
  }
  return false;
};

export const getCurrentUserEmail = () => {
  let userDetail = cacheManager.getItem("userDetail") && JSON.parse(cacheManager.getItem("userDetail"));
  if (userDetail !== null) {
    // GET CURRENT LOGGED IN USER EMAIL.
    return get(userDetail, "email");
  }
};

export const isTokenExistInCookies = () => {
  if (cookiesManager.getCookie(cookieKeysEnum["APP_SESSIONID"])) {
    return true;
  }
  return false;
};

export const getDomainFromSubDomain = (hostname: any) => {
  if (window.location.hostname !== "localhost") {
    const dotIndex = hostname.indexOf(".");
    return hostname.substring(dotIndex + 1);
  }
  return hostname;
};

export const noCookiesRedirectToLogin = () => {
  if (process.env.REACT_APP_LOGIN_BY_AZURE_AD == "true" && !isTokenExistInCookies()) {
    window.location.assign("/");
  }
};

export const callAPI = (url: any, verb: any, data: any, callback: any) => {
  let axioObj: any;
  switch (verb) {
    case "get":
      axioObj = axios.get(url, data);
      break;
    case "post":
      axioObj = axios.post(url, data);
      break;
    case "patch":
      axioObj = axios.patch(url, data);
      break;
    case "delete":
      axioObj = axios.delete(url, data);
      break;
    default:
    // DO Nothing
  }
  axioObj
    .then((response: any) => {
      callback(response);
    })
    .catch((err: any) => {
      callback({});
    });
};

let prevOrgName = "";
let TIMEOUT: any = null;

export const getMinutes = (cTime: any) => moment(cTime, "HH:mm:ss a").get("minutes");

export const isLocalhost = () => {
  return window.location.origin.includes("localhost");
};

// TODO : Get User Agitent (Identify request coming from browser.)
export const getUserAgent = () => {
  const test = (regexp: any) => regexp.test(window.navigator.userAgent);
  switch (true) {
    case test(/edg/i):
      return { name: "Edge", version: "" };
    case test(/trident/i):
      return { name: "IE", version: "" };
    case test(/firefox|fxios/i):
      return { name: "Firefox", version: "" };
    case test(/opr\//i):
      return { name: "Opera", version: "" };
    case test(/ucbrowser/i):
      return { name: "UC", version: "" };
    case test(/samsungbrowser/i):
      return { name: "Samsung", version: "" };
    case test(/chrome|chromium|crios/i):
      return { name: "Chrome", version: "" };
    case test(/safari/i):
      return { name: "Safari", version: "" };
    default:
      return { name: "Other", version: "" };
  }
};

export const commaSeperator = (value: any) => {
  // return  value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") ;
  return new Intl.NumberFormat("en-US").format(value);
};

export const encodeStreamData = (data: any) => {
  const str =
    data &&
    data.reduce(function (a: any, b: any) {
      return a + String.fromCharCode(b);
    }, "");
  return btoa(str).replace(/.{76}(?=.)/g, "$&\n");
};
export const downloadByUrl = (filename: any, url: any) => {
  fetch(url).then(function (t) {
    return t.blob().then((b) => {
      var a = document.createElement("a");
      a.href = URL.createObjectURL(b);
      a.setAttribute("download", filename);
      a.click();
    });
  });
};

// Generating year list
export const generateYearList = (yearsForward = 2) => {
  const currentYear = new Date().getFullYear();
  let yearOptionsList = [];
  let key = 0;
  const toYear = currentYear + yearsForward;
  for (let y = currentYear; y <= toYear; y++) {
    yearOptionsList.push({
      key: key,
      text: y,
      value: y,
    });
    key++;
  }
  return yearOptionsList;
};

export const setMinDate = () => {
  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 3, 0, 1);
  return minDate;
};

// Get previous month with date 01
export const getDateWithPreviousMonth = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  date.setDate(1);
  return date;
};

export const downloadDocument = (fileDataResponse: any, fileName: any) => {
  const arr = fileDataResponse.content.Body.data;
  const byteArray = new Uint8Array(arr);

  const a = window.document.createElement("a");
  a.href = window.URL.createObjectURL(new Blob([byteArray], { type: fileDataResponse.content.ContentType }));
  a.download = fileName || "";

  // Append anchor to body.
  document.body.appendChild(a);
  a.click();

  // Remove anchor from body
  document.body.removeChild(a);
};

export const downloadFileByBase64 = (fileContent: any, fileName: any) => {
  let a = window.document.createElement("a");
  a.href = "data:application/octet-stream;base64," + fileContent;
  a.download = fileName || "";
  // Append anchor to body.
  document.body.appendChild(a);
  a.click();
  // Remove anchor from body
  document.body.removeChild(a);
};

//get formatted date without slash
export const formatDateWithoutSlash = (date: any, dateFormat: any = "MMDDYYYY") => {
  return moment(date).format(dateFormat);
};

// TODO : enum for committee levels
export const COMMITTEE_LEVELS = {
  MAINCOMMITTEE: 1,
  SUBCOMMITTEE: 2,
  SECTION: 3,
};

export const MEMBERSHIP_REQUEST_TYPE = {
  NEWMEMBER: "New Member",
  RENEW: "Renewal",
  REINSTATE: "Reinstate",
  STUDENT_UPGRADE: "Student Upgrade",
};

export const EMAIL_TEMPLATE_NAME = {
  CHANGE_OF_EMPLOYMENT: "Change_Of_Employment_Email",
  CHANGE_OF_COMPANY_ADDRESS_EMAIL: "Change_Of_Company_Address_Email",
};

export const FORM_TYPE_ORG_UPDATE = {
  Member: "Member",
  Organization: "Organization",
};

export const canadaZipCodeFix = (str: any) => {
  if (str.length > 0 && str.includes("-")) return str.replace("-", " ");
  return str;
};

export const searchEventList = (self: any, trimmedValue: any) => {
  let { eventList } = self.state;
  let eventSearchList =
    eventList && eventList.length > 0
      ? eventList.filter((item: any) => {
          return (item.EventName && item.EventName.indexOf(trimmedValue) >= 0) || (item.EventName && item.EventName.toLowerCase().indexOf(trimmedValue.toLowerCase()) >= 0);
        })
      : [];
  if (eventSearchList.length > 0 && trimmedValue.length > 0) {
    self.setState({
      isLoading: false,
      eventSearchList,
      isOpen: true,
      showNoResultsMessage: eventSearchList.length === 0,
    });
  } else if (!trimmedValue) {
    self.setState({ eventSearchList: self.state.eventList }, () => {
      let { eventSearchList } = self.state;
      let showNoResultsMessage = eventSearchList.length > 0 ? false : true;
      self.setState({ isLoading: false, eventSearchList, isOpen: true, showNoResultsMessage: showNoResultsMessage });
    });
  } else if (eventSearchList.length === 0 && trimmedValue.length > 0) {
    self.setState({
      isLoading: false,
      eventSearchList: [],
      isOpen: true,
      showNoResultsMessage: eventSearchList.length === 0,
    });
  } else {
    self.setState({ isLoading: false, eventSearchList: [], isOpen: false });
  }
};

export const openApiPathArray = ["/master/featureflag"];

export const scrollToErrorOnFormHandler = () => {
  const fields = "input, select, textarea, .sidebar-selection-input"; // Increase Fields as per requirement.
  const currentFormSelector = document.querySelectorAll("form");
  // Wait for is-Invalid class attached into the fields.
  setTimeout(() => {
    // Get all form into single screen.
    for (let index = 0; index < currentFormSelector.length; index++) {
      if (currentFormSelector[index]) {
        const fieldsElements: any = currentFormSelector[index].querySelectorAll(fields);
        // Get all fields from Form references.
        for (let i = 0; i < fieldsElements.length; i++) {
          if ((fieldsElements[i].classList && fieldsElements[i].classList.value.indexOf("is-invalid") > -1) || (fieldsElements[i].offsetParent && fieldsElements[i].offsetParent.classList && fieldsElements[i].offsetParent.classList.value.indexOf("is-invalid") > -1)) {
            fieldsElements[i].scrollIntoView({ behavior: "smooth", block: "center" });
            return false;
          }
        }
      }
    }
  }, 100);
};

export const getFormattedDate = (date: any, format = "MM/DD/YYYY") => {
  if (!date) {
    return;
  }
  return moment(date).format(format);
};

export const encodeText = (text: string) => {
  return window.btoa(text);
};

export const formatFileSize = (bytes: number) => {
  if (bytes == 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  let i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const scrollToActiveItem = () => {
  const parentCurrent = document.querySelector("#render-table-for-documentlist");
  if (parentCurrent && parentCurrent.querySelectorAll("td").length > 0) {
    const fields = "a"; // Increase Fields as per requirement.
    const currentFormSelector = parentCurrent.querySelectorAll("td");
    // Wait for is-Invalid class attached into the fields.
    setTimeout(() => {
      // Get all form into single screen.
      for (let index = 0; index < currentFormSelector.length; index++) {
        if (currentFormSelector[index]) {
          const fieldsElements: any = currentFormSelector[index].querySelectorAll(fields);
          // Get all fields from Form references.
          for (let i = 0; i < fieldsElements.length; i++) {
            if ((fieldsElements[i].classList && fieldsElements[i].classList.value.indexOf("activeDocumentForDocumentInfo") > -1) || (fieldsElements[i].offsetParent && fieldsElements[i].offsetParent.classList && fieldsElements[i].offsetParent.classList.value.indexOf("activeDocumentForDocumentInfo") > -1)) {
              fieldsElements[i].scrollIntoView({ behavior: "smooth", block: "center" });
            }
          }
        }
      }
    }, 100);
  }
};

export const downloadFile = (data: any) => {
  let url = data.DownloadURL || data.DownloadUrl;
  let a = document.createElement("a");
  a.href = url;
  a.setAttribute("download", data.DocumentName);
  a.setAttribute("target", "_blank");
  document.body.append(a);
  a.click();
};

export const downloadFileInSameTab = (data: any) => {
  let url = data.DownloadURL;
  let a = document.createElement("a");
  a.href = url;
  a.setAttribute("download", data.DocumentName);
  document.body.append(a);
  a.click();
};

export const timeLocal = (date: string) => {
  return moment.utc(date).local().format("hh:mm A");
};

export const getApiUniqueRequestId = (url: string) => {
  try {
    const cachedValue = cacheManager.getItem("uniqueRequestIdForApis");
    if (!cachedValue) {
      return null;
    }

    const uniqueRequestIds = typeof cachedValue === "string" ? JSON.parse(cachedValue) : cachedValue;
    if (!uniqueRequestIds || typeof uniqueRequestIds !== "object") {
      return null;
    }

    for (let key in uniqueRequestIds) {
      if (url === key) {
        return uniqueRequestIds[key];
      }
    }
  } catch (e) {
    return null;
  }

  return null;
};

export const isValidDate = (date: string | Date) => {
  return date instanceof Date && !isNaN(date.getTime());
};

// Function returns date format in MM/DD/YYYY format
export const toLocalDateFormat = (dateString: string | Date) => {
  if (!dateString) {
    return null;
  }
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

// Get All Search Options
export const getSearchAllGlobalDropDownOptions = () => {
  let searchResult: any = [];
  NAVIGATIONHEADER && NAVIGATIONHEADER.map((moduleItem: any, index: number) => moduleItem[MODULES[index]] && moduleItem[MODULES[index]].map((subModuleItems: any, subIndex: number) => allowPermissionForAuth(filterPermissionUrl(subModuleItems)) && subModuleItems.searchParams !== null && searchResult.push(subModuleItems.searchParams)));
  const sortedResult = orderBy(searchResult, ["orderIndex"], ["asc"]);
  return sortedResult;
};

const secondaryItemStatusSort = (
  sortedItems: any[],
  order: number
) => {
  const result: any[] = [];
  let buffer: any[] = [];

  const flush = () => {
    if (!buffer.length) return;

    const statusId = buffer[0].BallotItemStatusId;

    buffer.sort((a, b) => {
      switch (Number(statusId)) {
        case 3:
          return order === 1
            ? new Date(b.ItemApprovalDate)?.getTime() -
                new Date(a.ItemApprovalDate)?.getTime()
            : new Date(a.ItemApprovalDate)?.getTime() -
                new Date(b.ItemApprovalDate)?.getTime();

        case 17:
          return order === 1
            ? Number(a.ItemNumber) - Number(b.ItemNumber)
            : Number(b.ItemNumber) - Number(a.ItemNumber);

        case 9:
          return order === 1
            ? a.NextBallotNumber?.localeCompare(b.NextBallotNumber)
            : b.NextBallotNumber?.localeCompare(a.NextBallotNumber);

        default:
          return 0;
      }
    });

    result.push(...buffer);
    buffer = [];
  };

  for (const item of sortedItems) {
    if (!buffer.length || buffer[0].ItemStatus === item.ItemStatus) {
      buffer.push(item);
    } else {
      flush();
      buffer.push(item);
    }
  }

  flush();
  return result;
};

export const tableSort = (
  items: any[],
  type: string,
  order: number,
  sortKey: string,
  secondarySortLabel?: string,
  specialSort?: string
) => {

  if (secondarySortLabel) {
    const primarySorted = items.sort((a, b) => {
      const committeeCompare = a[sortKey].localeCompare(b[sortKey]);
      if (committeeCompare !== 0) {
        return order === 1 ? committeeCompare : -committeeCompare;
      }
      const statA = Number(a[secondarySortLabel]);
      const statB = Number(b[secondarySortLabel]);
      return statA - statB;
    });
  }

  let sortedResults;
  let sortingArray = items
    .reduce(
      (acc, item) => {
        Number(order) === 1
          ? acc[item[sortKey] ? 1 : 0].push(item)
          : acc[item[sortKey] ? 0 : 1].push(item);
        return acc;
      },
      [[], []]
    )
    .flat();

  if (Number(order) === 1) {
    switch (type) {
      case 'alphanumeric':
        sortedResults = sortingArray.sort((a, b) => {
          if (a && b && a[sortKey] && b[sortKey]) {
            return String(a[sortKey]).localeCompare(String(b[sortKey]));
          }
          return 0;
        });
        break;

      case 'date':
        sortedResults = sortingArray.sort((a, b) => {
          if (a.PublishedDate && b.PublishedDate) {
            return (
              new Date(a.PublishedDate).getTime() -
              new Date(b.PublishedDate).getTime()
            );
          }
          return 0;
        });
        break;

      case 'numeric':
        sortedResults = sortingArray.sort(
          (a, b) => Number(a[sortKey]) - Number(b[sortKey])
        );
        break;
    }
  } else {
    switch (type) {
      case 'alphanumeric':
        sortedResults = sortingArray.sort((a, b) => {
          if (a && b && a[sortKey] && b[sortKey]) {
            return String(b[sortKey]).localeCompare(String(a[sortKey]));
          }
          return 0;
        });
        break;

      case 'date':
        sortedResults = sortingArray.sort((a, b) => {
          if (a.PublishedDate && b.PublishedDate) {
            return (
              new Date(b.PublishedDate).getTime() -
              new Date(a.PublishedDate).getTime()
            );
          }
          return 0;
        });
        break;

      case 'numeric':
        sortedResults = sortingArray.sort(
          (a, b) => Number(b[sortKey]) - Number(a[sortKey])
        );
        break;
    }
  }
  return specialSort === "ItemStatus"
    ? secondaryItemStatusSort(sortedResults, order)
    : sortedResults;
};

const getIncrementedDate = (createdDate, monthsToAdd) => {
  createdDate = new Date(createdDate);
  createdDate.setMonth(createdDate.getMonth() + monthsToAdd);

  return getFormattedDate(createdDate);
}
export const getCompletionDates = (createdDate: any, targetInterval: number) => {
  let startDate = '';
  let endDate = '';
  if (targetInterval === CompletionIntervalList[0].Id) {
     startDate = getIncrementedDate(createdDate, 3);
     endDate = getIncrementedDate(createdDate, 6);
  } else if (targetInterval === CompletionIntervalList[1].Id) {
     startDate = getIncrementedDate(createdDate, 6);
     endDate = getIncrementedDate(createdDate, 12);
  } else if (targetInterval === CompletionIntervalList[2].Id) {
     startDate = getIncrementedDate(createdDate, 12);
     endDate = getIncrementedDate(createdDate, 18);
  } else if (targetInterval === CompletionIntervalList[3].Id) {
     startDate = getIncrementedDate(createdDate, 18);
     endDate = getIncrementedDate(createdDate, 24);
  }
  return { startDate, endDate };
}

export const formatDateToMMDDYYYY = (date:any = undefined, format = "MM/DD/YYYY") => {
  if (date) {
    return moment(date).format(format);
  }

  const now = new Date();
  return moment(now).format(format);
};

export const getStartDateOfCurrentMonth = () => {
  const date = new Date();
  return formatDateToMMDDYYYY(new Date(date.getFullYear(), date.getMonth(), 1));
};


export const checkIfDateValid = (date:any, format:any) => {
  if (date) {
    let sptArr = date?.split("/");
    if (sptArr !== null && sptArr.length === 3) {
      if (sptArr[2] === "0000") {
        return false;
      }
    }
  }

  return moment(date, format, true).isValid();
};
// Returns true if date1 is greater than date2
export const compareDates = (date1:any, date2 :any, checkOnlyGreaterThan:boolean = false, format:string = "MM/DD/YYYY") => {
  if (checkOnlyGreaterThan) {
    return moment(date1, format, true) > moment(date2, format, true);
  }
  return moment(date1, format, true) >= moment(date2, format, true);
};
export const validateAuditLogDates = (values, props) => {
  const errors:any = {};
  let currentDate = formatDateToMMDDYYYY();

  if (values.dateFrom && !checkIfDateValid(values.dateFrom, "MM/DD/YYYY")) {
    errors.dateFrom = getMessage(props.messageCodes, "2009.text");
  } 

  if (values.dateTo && !checkIfDateValid(values.dateTo, "MM/DD/YYYY")) {
    errors.dateTo = getMessage(props.messageCodes, "2009.text");
  } 
  
  if (checkIfDateValid(values.dateFrom, "MM/DD/YYYY") && checkIfDateValid(values.dateTo, "MM/DD/YYYY") && moment(values.dateFrom, "MM/DD/YYYY", true) > moment(values.dateTo, "MM/DD/YYYY", true)) {
    errors.dateFrom = getMessage(props.messageCodes, "2007.text");
  }

  return errors;
};

export const minDateForAuditLogs = '01/01/1700';
  // Function to allow alpha numeric positive  characters
  export const allowAlphaNumericPositiveInput = (e:any) => {
    if (!AlphaNumeric_Regex.test(e.key)) {
      e.preventDefault();
    }
  };

  export const allowAlphaNumericPositiveInputWithDash = (e:any) => {
    if (!AlphaNumericWitDash_Regex.test(e.key)) {
      e.preventDefault();
    }
  }

export const removeLeadingZeroes =(wkNumber : any)=>{
  return wkNumber && wkNumber.replace(/^WK0*(\d+)$/, 'WK$1')
}
export const getSubCommitte =(subCommitte : any)=>{
  let subCommittee;
  const committees = subCommitte.split(".")
  if(committees.length == 3){
    subCommittee = committees[1] + committees[2]
  }else if(committees.length == 2){
    subCommittee = committees[1] + "00"
  }else{
    subCommittee = "0000"
  }  
  return subCommittee
}
export const getExtensionIcon = (extension:string) => {
  if (extension === "ppt" || extension === "pptx") {
    return "file-powerpoint";
  }
  if (extension === "xls" || extension === "xlsx") {
    return "file-excel";
  }
  if (extension === "doc" || extension === "docx") {
    return "file-word";
  }
  if(extension ==="zip"){
    return "file-archive"
  }
  if (extension === "pdf") {
    return "file-pdf";
  }
  return "file-alt";
};

export const getMethodForPermissionType = (permissionType: string): string | null => {
  switch (permissionType) {
    case "All":
      return "ALL";
    case "View":
      return "POST";
    case "Add":
      return "POST";
    case "Update":
      return "PUT";
    case "Delete":
      return "DELETE";
    case "Publish":
      return "PUT";
    default:
      return null;
  }
};

export const ballotItemActionPreference = {
  PermanentDelete: 'PermanentDelete',
  ItemBackToQueue: 'itemBackToQueue',
  BulkPermanentDelete: 'BulkPermanentDelete',
  BulkItemBackToQueue: 'BulkItemBackToQueue',
  RemoveItemFromBallot: 'RemoveItemFromBallot'
}

export const BallotActionForQueue = [
  { key: 'New Standard' , value: 1 },
  { key: 'Revision' , value: 2 },
  { key: 'Revision of New Std' , value: 3 },
  { key: 'Revision W/Title Chg' , value: 4 },
  { key: 'Rev W/Chg in Desig' , value: 5 },
  { key: 'Reinstate W/Ed Chg' , value: 6 },
  { key: 'Reinstate' , value: 7 },
  { key: 'Reinstate W/Rev' , value: 8 },
  { key: 'Reapproval' , value: 9 },
  { key: 'Reapproval W/Ed Chg' , value: 10 },
  { key: 'Withdraw - No Repl' , value: 11 },
  { key: 'Withdraw Replace By' , value: 12 },
  { key: 'Administrative' , value: 13 },
  { key: 'Uphold Negative' , value: 14 },
  { key: 'Reinstate W/New Des' , value: 15 },
  { key: 'Withdraw Combined' , value: 16 },
  { key: 'Confirmatory' , value: 17 }
]

export const getRedirectUrl = (appName: string, module: string, value: string) => {
  let url = "";
  if (appName === Apps.IA) {
    if (module === AppModule.Member) {
      url += process.env.REACT_APP_IA_URL + "/member-management/members/details/" + value;
    } else if (module === AppModule.Committee) {
      url += process.env.REACT_APP_IA_URL + "/committee-management/committees/details/" + value;
    } else if (module === AppModule.user ){
      url += process.env.REACT_APP_IA_URL + "/admin/user/detail/" + value;
    }
  } else if (appName === Apps.BEVSON) {
    if (module === AppModule.WorkItem) {
      url += LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL + "/" + value;
    }
  } else if (appName === Apps.BEVSON) {
    if (module === AppModule.WorkItem) {
      url += LEFT_NAVIGATION_PAGE_URL.WORKITEMDETAIL + "/" + value;
    }
  } else if (appName === Apps.STDMAINT) {
    if (module === AppModule.Ballot) {
      url += EXTERNAL_APP_URL.STDMAINT_APP_DETAIL + "/" + value;
    }
  }
  return url;
};

export const getConcurrentLabel = (BallotLevelId,CCBallotTrackingId,ballotStatus)=>{
    if ([BallotStatusType.Publish, BallotStatusType.Closed].includes(ballotStatus) && BallotLevelId === 5 ){
      return true
    } else if(![BallotStatusType.Publish, BallotStatusType.Closed].includes(ballotStatus) && CCBallotTrackingId){
      return true
    } 
    return false;
  }

export const ScrollPage = (position: number) => {
  position = window.pageYOffset == 0 ? window.innerHeight : window.pageYOffset;
  window.scrollBy({ top: position });
};

export const toUTCDate = (utcString: string | Date): Date => {

  const hasTimezone = typeof(utcString) === "string" && /([+-]\d{2}:?\d{2}|Z)$/.test(utcString);

  const utcDate = (hasTimezone && typeof(utcString) === "string")
    ? utcString
    : (!hasTimezone && typeof(utcString) === "string")
    ? `${utcString}Z`
    : utcString;

  const options: Intl.DateTimeFormatOptions = {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const easternFormatter = new Intl.DateTimeFormat("en-US", options);
  const formattedEasternTime = easternFormatter.format(new Date(utcDate));
  return new Date(formattedEasternTime);
}

export const getFileName = (committee, stdDesignation, wiNumber, createdDate, bqSrNo="BQ_temp") => {
  bqSrNo = bqSrNo + (Math.floor(Math.random() * 1000) + 1)
  let mainCommittee = committee.split(".").length > 0 ? committee.split(".")[0] : "";
  let subCommittee = committee.split(".").length > 1 ? committee.split(".")[1] : "";
  let secCommittee = committee.split(".").length > 2 ? committee.split(".")[2] : "";
  let _stdDesignation = stdDesignation ? `${stdDesignation}_` : "";
  return `${mainCommittee}_${subCommittee ? subCommittee : "00"}${secCommittee ? secCommittee : "00"}_${_stdDesignation}${wiNumber}_${createdDate}_${bqSrNo}`;
};

export const removeExtension = (filename) => {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1) {
    return filename;
  }
  return filename.substring(0, lastDotIndex);
};

export const isValidWIStatusField = (key, status) => {
  if (WI_STATUS_FIELDS_MAP.hasOwnProperty(key)) {
    return WI_STATUS_FIELDS_MAP[key].includes(status);
  }
  return true;
}

export const getRuleEditorValidations = (response: Record<string, any>): Record<string, any> | boolean => {
  if (!response) {
    return false;
  }
  if (response.status) {
    const errorContent: Record<string, any>[] = response.content?.filter(content => !content.Status && content.ErrorLevel?.toLowerCase() === "error");
    const warningContent: Record<string, any>[] = response.content?.filter(content => !content.Status && content.ErrorLevel?.toLowerCase() === "warning");
    if (!errorContent?.length && !warningContent.length) {
      return false
    }
    return { errors: errorContent, warnings: warningContent, length: errorContent?.length + warningContent?.length };
  }
  return false;
}

export function normalizeData(arr) {
  return arr.reduce(
    (acc, item) => {
      acc.errors.push(...(item.errors || []));
      acc.warnings.push(...(item.warnings || []));
      acc.length += item.length || 0;
      return acc;
    },
    { errors: [], warnings: [], length: 0 }
  );
}

export const getTenPercentOfCloseDate = (
  issueDate: Date,
  initialCloseDate: Date
): boolean => {

  const MS_PER_DAY = 1000 * 60 * 60 * 24;
  const diffInDays = Math.ceil(
    (initialCloseDate.getTime() - issueDate.getTime()) / MS_PER_DAY
  );

  const tenPercentDays = Math.ceil(diffInDays * 0.1);

  const tenPercentDate = new Date(initialCloseDate);
  tenPercentDate.setDate(tenPercentDate.getDate() - tenPercentDays);

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  tenPercentDate.setHours(0, 0, 0, 0);  
  return tenPercentDate.getTime() <= today.getTime();
};

export const generateFullName = (
  firstName: string,
  middleName?: string,
  lastName?: string
): string => {
  const firstMiddle = [firstName, middleName].filter(Boolean).join(" ");

  return lastName ? `${lastName}, ${firstMiddle}` : firstMiddle;
};

export const getRulingTitle = (negativeId: number) => {
  const negativeStatus = NEGATIVE_RULING_OPTIONS.find((e) => e?.value === negativeId);
  return negativeStatus?.label
}

export const removeHtmlTags = (html: string): string => {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || "";
};

export const base64ToBlob = (base64: string, contentType: string) => {
  const byteChars = atob(base64);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
}

const STATUS_PAIR_MAP: Record<number, number> = {
  [BALLOT_ITEM_STATUSES["Hold SOC"]]: DRAFT_STATUSES.SOCIETY_REVIEW,
  [BALLOT_ITEM_STATUSES["APP-HOLD"]]: DRAFT_STATUSES.BALLOTING_ON_HOLD,
  [BALLOT_ITEM_STATUSES["Pending Next Level"]]: DRAFT_STATUSES.PENDING_NEXT_LEVEL,
  [BALLOT_ITEM_STATUSES["Passed"]]: DRAFT_STATUSES.RECONSIDER,
  [BALLOT_ITEM_STATUSES["Pending Approval"]]: DRAFT_STATUSES.PENDING_APPROVAL,
  [BALLOT_ITEM_STATUSES["Item Removed"]]: DRAFT_STATUSES.ITEM_REMOVED,
};

export const isItemWitnEqual = (itemStatusId: number, withStatusId: number): boolean => {
  return STATUS_PAIR_MAP[itemStatusId] === withStatusId;
};

export const hasReactivateOnrPermisssion = (trackingItem: any, ballotStatusId: number, ballotTypeId: number) => {
  const hasPermission = [BALLOT_LEVEL_ID.MAIN, BALLOT_LEVEL_ID.SUB, BALLOT_LEVEL_ID.COS].includes(trackingItem?.BallotLevelId) &&
    // Ballot status is ‘Closed’
    ballotStatusId === BallotStatusEnum.Closed &&
    // Ballot Item is ‘Technical’
    ballotTypeId === BallotTypeEnum.Technical &&
    // Excluding UN/CF items
    ![DraftActionId.Confirmatory, DraftActionId.Uphold_Negative].includes(trackingItem?.DraftActionId) &&
    !trackingItem?.IsReactivatedOnr &&
    // Negative Votes are submitted on Ballot Item
    trackingItem?.TotalNegative > 0 &&
    // Item Status and Witn Status
    isItemWitnEqual(Number(trackingItem?.BallotItemStatusId), Number(trackingItem?.CurrentDraftStatusId)) === true;

  return hasPermission;
};

export default {
  Blank_Space_Check_Regex,
  AlphaNumeric_Regex,
  Name_Regex,
  PositiveRegex,
  Number_Regex,
  getCookie,
  getFileType,
  getCurrentlyShowingItemsInGrid,
  scrollToTopOfPage,
  utcDateTimeToLocalDateTime,
  utcDateTimeSecondToLocalDateTime,
  utcDateTimeSecondToDate,
  extractValueFromUrl,
  getMessage,
  getSortOrderFromHeaderClick,
  resetHeaderSortOrder,
  formatListDataForAutoSearch,
  generateUUID,
  generateUUIDForAutofill,
  validateNavigationFromUrl,
  filterPermissionUrl,
  allowPermissionForAuth,
  routeNavigationUrl,
  getModulesAdditionalPrivilege,
  azureAdFetchCode,
  validateNavigationPermission,
  setLoginDataToCacheManager,
  isReactAppAuthorized,
  clearAzureAdAuthCodeAction,
  getCurrentUserEmail,
  cookiesManager,
  isTokenExistInCookies,
  noCookiesRedirectToLogin,
  getMinutes,
  getUserAgent,
  commaSeperator,
  encodeStreamData,
  downloadByUrl,
  downloadDocument,
  downloadFileByBase64,
  formatDateWithoutSlash,
  searchEventList,
  openApiPathArray,
  scrollToErrorOnFormHandler,
  getFormattedDate,
  encodeText,
  formatFileSize,
  scrollToActiveItem,
  downloadFile,
  timeLocal,
  getApiUniqueRequestId,
  getSearchAllGlobalDropDownOptions,
  tableSort,
  getCompletionDates,
  formatDateToMMDDYYYY,
  getStartDateOfCurrentMonth,
  toUTCDateAndTime,
  allowAlphaNumericPositiveInput,
  getSubCommitte,
  getMethodForPermissionType,
  getRedirectUrl,
  ScrollPage,
  toUTCDate,
  getFileName,
  removeExtension,
  getTenPercentOfCloseDate,
  allowAlphaNumericPositiveInputWithDash,
  validateAuditLogDates,
  minDateForAuditLogs,
  base64ToBlob,
  isItemWitnEqual,
  hasReactivateOnrPermisssion
};
